import React, { push, Component } from "react";
import {
  Grommet,
  Box,
  Header,
  Button,
  Layer,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  Card,
  CardHeader,
  CardBody,
  List,
  Grid,
  TextInput,
  Select,
  RadioButtonGroup,
  Form,
  CheckBox,
  DateInput,
  FormField,
  CheckBoxGroup,
  Tabs,
  Tab,
  Image,
  CardFooter,
  IFrame,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Console,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  CaretDownFill,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Filter,
  Video,
  DocumentPdf,
  Inspect,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";

class GetHelpL3 extends Component {
  // const { push } = React.useContext(RouterContext)

  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <Layer
        full={true}
        position="center"
        height="medium"
        onClickOutside={this.props.hide}
        onEsc={this.props.hide}
      >
        <Box fill="vertical" align="stretch" justify="start">
          <Main
            overflow="auto"
            background={{ image: "url('')" }}
            flex
            align="stretch"
            justify="start"
          >
            <Box
              align="stretch"
              justify="center"
              flex="grow"
              background={{ color: "background-back" }}
              direction="row"
            >
              <Box
                align="stretch"
                justify="start"
                flex="shrink"
                pad={{ horizontal: "large", vertical: "medium" }}
                basis="xlarge"
                direction="column"
                gap="medium"
              >
                <Box align="center" justify="end" direction="row">
                  <Button
                    icon={<Close />}
                    onClick={this.props.hide}
                    secondary
                  />
                </Box>
                <Header
                  align="start"
                  direction="column"
                  flex={false}
                  justify="start"
                  gap="xxsmall"
                >
                  {/*  <Button
                    label="Back"
                    icon={<FormPrevious />}
                    onClick={() => push("/gethelp-live")}
                  /> */}
                  <Heading margin="none">
                    Get Help - Cannot open .ica file
                  </Heading>
                </Header>
                <Box
                  align="stretch"
                  justify="center"
                  pad="medium"
                  gap="large"
                  direction="column"
                >
                  <Card hoverIndicator>
                    <CardHeader
                      align="start"
                      direction="column"
                      justify="start"
                      flex
                    >
                      <Box align="center" justify="center" direction="row">
                        <Heading size="small" level="4">
                          The Issue:
                        </Heading>
                      </Box>
                      <Box align="center" justify="center" direction="row">
                        <Paragraph size="medium">
                          .ica files are files in which the citrix receiver can
                          open and then allow you to access your live demos vm.
                        </Paragraph>
                        <Image
                          src="/img/GetHelp/GHL3-icaOpenIssue.png
"
                          fit="contain"
                        />
                      </Box>
                    </CardHeader>
                    <CardBody
                      direction="column"
                      justify="start"
                      align="stretch"
                    >
                      <Heading size="small" level="4">
                        The Resolution:
                      </Heading>
                      <Paragraph size="medium" textAlign="start" fill>
                        All you should have to do is do a search for default
                        apps on your computer and open it. Then inside the
                        default apps area if you scroll down you should see an
                        option that says Choose default apps by file type, click
                        on this. After you click on this. It should show a list
                        of file type options,what you want to do is scroll down
                        until you see the file type .ica . what you want to do
                        is scroll down until you see the file type .ica If you
                        have the citrix receiver installed correctly you should
                        see citrix connection manager to pop up as a selectable
                        option.
                      </Paragraph>
                      <Paragraph
                        size="medium"
                        textAlign="start"
                        fill
                        color="brand"
                      >
                        Sometimes on some occasions it can take a
                        re-installation of Citrix receiver
                      </Paragraph>
                      <Box
                        align="start"
                        justify="start"
                        border={{ color: "brand" }}
                      >
                        <Paragraph size="medium" fill>
                          Go to control panel – programs – and uninstall citrix
                          receiver Run citrix receiver remover tool.
                        </Paragraph>
                        <Anchor
                          label="Citrix Remover tool (right click)"
                          href="https://drive.google.com/file/d/1DXPoXFIVXFpuzjSrcnHBUk6GzkdmAwz2/view?usp=sharing"
                        />
                        <Paragraph size="medium" fill>
                          After the tool has finished running, "HPE
                          Demonstration Portal - Upcoming demos" and try and
                          launch your demo You should be prompted to install
                          Citrix Receiver, if not and it brings you to the
                          citrix storefront, click on your name in the top right
                          and click install citrix receiver That should download
                          the latest install file of the citrix receiver Run the
                          setup file After that’s done try and launch the vm
                          from the citrix storefront and it should launch
                        </Paragraph>
                      </Box>
                    </CardBody>
                    <CardFooter
                      align="center"
                      direction="row"
                      flex={false}
                      justify="between"
                      gap="medium"
                      pad="small"
                    >
                      <Text size="xsmall">#GH-L3</Text>
                    </CardFooter>
                  </Card>
                </Box>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}
export default GetHelpL3;
